import * as React from "react";
import Dispatcher from "./Dispatcher";
import {Container} from "flux/utils";
import FixtureStore from "./stores/FixtureStore";
import "./fixture.css";
import {IFixturesPageViewProps, FixturesPageView} from "./views/FixturesPageView";
import * as moment from 'moment';

export interface IFixturesPageProps {
}

class FixturesPageContainer extends React.Component<IFixturesPageProps, IFixturesPageViewProps> {
    public render(): React.ReactElement<any> {
        return <FixturesPageView {...this.state} />;
    }

    public static getStores() {
        return [
            FixtureStore
        ];
    }

    public componentDidMount() {
        //Get fixtures from current date (or do in view?)
        let from = moment().startOf('day').valueOf();
        let to = moment().endOf('day').valueOf();
        FixturesPageContainer.getFixtures(from, to);
    }

    private static getFixtures(from, to) {
        Dispatcher.dispatch({
            type: "fixtures/start-load",
            from: from,
            to: to,
            requestId: FixturesPageView.randomId()
        })
    }

    public static calculateState(prevState: IFixturesPageViewProps, props: IFixturesPageProps) {
        return {
            fixtureLoader: FixtureStore.getState().getLoadObject().map(s => s.fixtures),
            getFixtures: FixturesPageContainer.getFixtures
        };
    }


}

export default Container.create(FixturesPageContainer, { withProps: true });
